import httpApiApplication from 'app/http/httpApiApplication';

import { type TemplateWeb } from './types';

export const getNotes = (language: string): Promise<TemplateWeb> => {
  return httpApiApplication.get('/payments/declaration/notes?language=' + language);
};
